import config from 'config';

import { AttributeDefinition } from './attribute-definition';
import { attributeDefinitionComparator } from './attribute-definition-utils';
import { KnownAttributes } from './known-attributes';

export const RUN_SIZE_ATTRIBUTE_INT: AttributeDefinition = {
  name: KnownAttributes.Size,
  type: 'int',
};

export const MONITORING_TIME_ATTRIBUTE_INT: AttributeDefinition = {
  name: KnownAttributes.MonitoringTime,
  type: 'int',
};

type CreateAttributeDefinitionFilterOptions<T extends AttributeDefinition> = {
  excludedAttributes?: AttributeDefinition[];
  hideRunSize?: boolean;
  hideMonitoringTime?: boolean;
  additionalFilter?: (attribute: T) => boolean;
};

export function createAttributeDefinitionFilter<T extends AttributeDefinition>({
  excludedAttributes = [],
  hideRunSize,
  hideMonitoringTime,
  additionalFilter,
}: CreateAttributeDefinitionFilterOptions<T>): (attribute: T) => boolean {
  const isHideRunSizeEnabled = hideRunSize ?? config.hideRunSize;
  const isHideMonitoringTimeEnabled = hideMonitoringTime ?? config.hideMonitoringTime;

  return (attribute: T) => {
    if (additionalFilter && !additionalFilter(attribute)) {
      return false;
    }

    if (
      excludedAttributes.length > 0 &&
      excludedAttributes.some((excluded) => attributeDefinitionComparator(attribute, excluded))
    ) {
      return false;
    }

    if (isHideRunSizeEnabled && attributeDefinitionComparator(attribute, RUN_SIZE_ATTRIBUTE_INT)) {
      return false;
    }

    if (
      isHideMonitoringTimeEnabled &&
      attributeDefinitionComparator(attribute, MONITORING_TIME_ATTRIBUTE_INT)
    ) {
      return false;
    }

    return true;
  };
}
